import React from "react";
import { useRef } from "react";
import { useCallback } from "react";

export default function useHorizontalDragScroll() {
  const ref = useRef(null);
  const dragging = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  const onMouseDown = useCallback((e) => {
    if (!ref.current) return;
    dragging.current = true;
    startX.current = e.pageX - ref.current.offsetLeft;
    scrollLeft.current = ref.current.scrollLeft;
  }, []);

  const onMouseMove = useCallback((e) => {
    if (!dragging.current || !ref.current) return;
    e.preventDefault();
    const x = e.pageX - ref.current.offsetLeft;
    const walk = (x - startX.current) * 1.5;
    ref.current.scrollLeft = scrollLeft.current - walk;
  }, []);

  const stop = useCallback(() => {
    dragging.current = false;
  }, []);

  return { onMouseDown, onMouseLeave: stop, onMouseMove, onMouseUp: stop, ref };
}
